// import React, { useEffect, useRef, useState } from "react";
// import { apiCall } from "../../../../utils/axiosService";
// import { API_URL } from "../../../../utils/apiRoutes";
// import { apiResponse } from "../../../../utils/apiResponse";
// import { Line } from "react-chartjs-2";
// import {
//     Chart,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Tooltip,
//     Legend,
//     PointElement,
//     LineElement,
//     Filler,
// } from "chart.js";
// import { commonService } from "../../../../utils/commonService";
// import { Button, Form } from "react-bootstrap";
// import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
// import { compName } from "../../../../utils/constant";
// import { useDispatch, useSelector } from "react-redux";
// import WidgetDetailModal from "../../WidgetDetailModal";
// import AddWidgetModal from "../../AddWidgetModal";
// import Comments from "../Comments/Comment";
// import { setBookingPaceMonth } from "../../../../utils/slices/headerPropertySlice";
// import moment from "moment";

// const BookinPaceChart = ({
//     setCompDataFromChild,
//     rowIndex,
//     colIndex,
//     api,
//     para,
//     setting,
// }) => {

//     const [SelectedOption, setSelectedOption] = useState("Revenue");
//     const dispatch = useDispatch();
//     let datesArray = commonService.getAllDatesInMonth(
//         new Date(para?.asOfDate).getFullYear(),
//         new Date(para?.asOfDate).getMonth()
//     );

//     const [showNoteSidebar, setShowNoteSidebar] = useState(false);
//     const [widgetModal, setWidgetModal] = useState(false);
//     const widgetDetailRef = useRef();
//     const propertyDetailFromRTK = useSelector(
//         (store) => store.headerProperty.propertyDetail
//     );
//     const bookingPaceMonth = useSelector(
//         (store) => store.headerProperty.bookingPaceMonth
//     );
//     const defaultAsOfDateRtk = useSelector(
//         (store) => store.headerProperty.defaultAsOfDate
//     );
//     const closeWidgetModal = () => {
//         setWidgetModal(false);
//     };
//     const closeNoteSideBar = () => {
//         setShowNoteSidebar(false);
//     };

//     const [chartData, setChartData] = useState(null);
//     const [selectedMonth, setSelectedMonth] = useState("");
//     const [monthList, setMonthList] = useState(null);

//     let prevYear = {
//         label: "Prev Year",
//         backgroundColor: "#97C2E0",
//         data: [],
//         stack: "stack1",
//     };

//     let currentYear = {
//         label: "Current Year",
//         backgroundColor: "#7ACFA2",
//         data: [],
//         stack: "stack2",
//     };

//     const getBookingPaceDetail = async () => {
//         let bookingPaceResponse = await apiCall(
//             {
//                 method: "POST",
//                 url: API_URL.BASE_API_URL.SnapShot + API_URL.BOOKING_PACE.CHART,
//                 body: {
//                     AsOfDate: bookingPaceMonth ? bookingPaceMonth : para?.asOfDate,
//                     propertyCode: para?.propertyCode,
//                 },
//             },
//             false
//         );

//         let response = apiResponse(false, bookingPaceResponse);

//         if (response?.isValidate) {
//             let dataFromApi = response?.data?.data;

//             datesArray?.map((item) => {
//                 let findData = dataFromApi?.filter((x) => {
//                     if (
//                         x?.Dates && commonService.convertDateInTimezone(x?.Dates).getDate() === item
//                     ) {
//                         return x;
//                     }
//                 });
//                 if (findData && findData.length > 0) {
//                     if (SelectedOption === "Revenue") {
//                         prevYear.data = [
//                             ...prevYear.data, findData?.[0]?.TotalRevenuePreviousYear ? findData?.[0]?.TotalRevenuePreviousYear : 0,
//                         ];
//                         currentYear.data = [
//                             ...currentYear.data, findData?.[0]?.TotalRevenueCurrentYear ? findData?.[0]?.TotalRevenueCurrentYear : 0,
//                         ];
//                     }
//                     else if (SelectedOption === "Room Sold") {
//                         prevYear.data = [
//                             ...prevYear.data, findData?.[0]?.TotalRMSPreviousYear ? findData?.[0]?.TotalRMSPreviousYear : 0,
//                         ];
//                         currentYear.data = [
//                             ...currentYear.data, findData?.[0]?.TotalRMSCurrentYear ? findData?.[0]?.TotalRMSCurrentYear : 0,
//                         ];
//                     }
//                     else if (SelectedOption === "ADR") {
//                         prevYear.data = [
//                             ...prevYear.data, findData?.[0]?.TotalADRPreviousYear ? findData?.[0]?.TotalADRPreviousYear : 0,
//                         ];
//                         currentYear.data = [
//                             ...currentYear.data, findData?.[0]?.TotalADRCurrentYear ? findData?.[0]?.TotalADRCurrentYear : 0,
//                         ];
//                     }

//                 }
//             });

//             setChartData([prevYear, currentYear]);
//         }

//         if (!response?.isValidate) {
//             prevYear.data = [
//                 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
//                 0, 0, 0, 0, 0, 0, 0,
//             ];
//             currentYear.data = [
//                 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
//                 0, 0, 0, 0, 0, 0, 0,
//             ];
//             setChartData([prevYear, currentYear]);
//         }
//     };

//     let chartDetail = {};

//     if (chartData) {
//         chartDetail = {
//             labels: datesArray,
//             datasets: [
//                 {
//                     type: "line",
//                     label: `${new Date().getFullYear() - 1}`,
//                     backgroundColor: chartData?.[0]?.backgroundColor,
//                     data: chartData?.[0]?.data,
//                     stack: chartData?.[0]?.stack || "default",
//                     fill: {
//                         target: "origin",
//                         above: "rgba(151, 194, 224, 0.4)",
//                     },
//                 },
//                 {
//                     type: "line",
//                     label: `${new Date().getFullYear()}`,
//                     backgroundColor: chartData?.[1]?.backgroundColor,
//                     data: chartData?.[1]?.data,
//                     // fill: true,
//                     fill: {
//                         target: "origin",
//                         above: "rgba(122, 207, 162, 0.4)",
//                     },
//                     stack: chartData?.[1]?.stack || "default",
//                 },
//             ],
//         };
//     }

//     let chartOptions = {
//         indexAxis: "x",

//         scales: {
//             x: {
//                 stacked: true,
//                 title: {
//                     display: true,
//                     text: "Date",
//                 },
//                 ticks: {
//                     align: "start",
//                     autoSkip: false,
//                 },
//             },
//             y: {
//                 beginAtZero: true,
//                 title: {
//                     display: true,
//                     text: SelectedOption,
//                 },
//                 grid: {
//                     display: true,
//                 },
//                 offset: true,
//                 ticks: {
//                     callback: function (value) {
//                         return SelectedOption === "Revenue" || SelectedOption === "ADR" ? `${propertyDetailFromRTK?.currency_term ? propertyDetailFromRTK?.currency_term : "$"}${value}` : value;
//                     },
//                 },
//             },
//         },

//         plugins: {
//             legend: {
//                 display: true,
//                 align: "end",
//                 position: "top",
//                 maxWidth: 20,
//                 maxHeight: 100,
//                 labels: {
//                     boxWidth: 10,
//                     boxHeight: 10,
//                 },
//             },
//             tooltip: {
//                 enabled: true,
//                 mode: "index",
//                 callbacks: {
//                     title: function (context) {
//                         return context[0].label;
//                     },
//                     label: function (context) {
//                         let label = context.dataset.label;
//                         let value = context.formattedValue;
//                         return `${label}: ${value}`;
//                     },
//                 },
//             },
//         },

//         responsive: true,

//         barThickness: 12,

//         categorySpacing: 0.3,

//         barPercentage: 0.8,

//         categoryPercentage: 0.9,
//     };

//     Chart.register(
//         CategoryScale,
//         LinearScale,
//         BarElement,
//         Tooltip,
//         Legend,
//         PointElement,
//         LineElement,
//         Filler
//     );

//     useEffect(() => {
//         if (api === 0) {
//             prevYear.data = [
//                 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
//                 0, 0, 0, 0, 0, 0, 0,
//             ];
//             currentYear.data = [
//                 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
//                 0, 0, 0, 0, 0, 0, 0,
//             ];
//             setChartData([prevYear, currentYear]);
//         } else {
//             if (para?.asOfDate) {
//                 if (!monthList) {
//                     let monthsData = commonService.getMonthNamesUntil(para?.asOfDate);
//                     setMonthList(monthsData);
//                     if (monthsData) {
//                         setSelectedMonth(monthsData[monthsData.length - 1]);
//                     }
//                 }

//                 getBookingPaceDetail();
//             }
//         }
//     }, [para?.asOfDate]);

//     useEffect(() => {
//         if (api !== 0) {
//             getBookingPaceDetail();
//         }
//     }, [bookingPaceMonth, SelectedOption]);

//     return (
//         <div className="widget-container" style={{ position: "relative" }}>
//             {api !== 0 && (
//                 <div className="gap-1 widget-container-menu">
//                     <Button className="heading-menu-btns" type="button">
//                         <img
//                             src={infoIcon}
//                             alt="info"
//                             onClick={() => {
//                                 widgetDetailRef.current = {
//                                     widgetdetails: "",
//                                     usernote: "",
//                                     compName: compName?.bookingPaceChart,
//                                     widgetId: para?.widgetId,
//                                 };
//                                 setWidgetModal(true);
//                             }}
//                         />
//                     </Button>
//                 </div>
//             )}
//             <div class="d-flex gap-2 align-items-center">
//                 <Form.Select
//                     className="width150 mb-2"
//                     value={selectedMonth}
//                     onChange={(e) => {
//                         let lastDate = "";
//                         if (e.target.value !== "") {
//                             const date = moment(
//                                 `${e.target.value} ${new Date().getFullYear()}`,
//                                 "MMMM YYYY"
//                             );
//                             lastDate = date.endOf("month").format("YYYY-MM-DD");
//                             if (moment(defaultAsOfDateRtk).isSameOrBefore(lastDate)) {
//                                 lastDate = defaultAsOfDateRtk;
//                             }
//                         }
//                         dispatch(setBookingPaceMonth(lastDate));
//                         setSelectedMonth(e.target.value);
//                     }}
//                 >
//                     <option value="">Select Month</option>
//                     {monthList?.map((item, index) => (
//                         <option key={item} value={item}>
//                             {item}
//                         </option>
//                     ))}
//                 </Form.Select>
//                 <div className="form-groups form-groups-radio-btn">
//                     <div className="form-groups-radio">
//                         <div className="form-radio">
//                             <input
//                                 type="radio"
//                                 className="form-check-input"
//                                 name="radioGroup2"
//                                 value="Revenue"
//                                 id="Revenue"
//                                 checked={SelectedOption === "Revenue" ? true : false}
//                                 onClick={() => {
//                                     setSelectedOption("Revenue");
//                                 }}
//                             />
//                             <Form.Check.Label htmlFor="Revenue" className="label-radio">
//                                 Revenue
//                             </Form.Check.Label>
//                         </div>
//                         <div className="form-radio">
//                             <input
//                                 type="radio"
//                                 className="form-check-input"
//                                 name="radioGroup2"
//                                 value="Room Sold"
//                                 id="RoomSold"
//                                 checked={SelectedOption === "Room Sold" ? true : false}
//                                 onClick={() => {
//                                     setSelectedOption("Room Sold");
//                                 }}
//                             />
//                             <Form.Check.Label
//                                 htmlFor="RoomSold"
//                                 className="label-radio"
//                             >
//                                 Room Sold
//                             </Form.Check.Label>
//                         </div>
//                         <div className="form-radio">
//                             <input
//                                 type="radio"
//                                 className="form-check-input"
//                                 name="radioGroup2"
//                                 value="ADR"
//                                 id="ADR"
//                                 checked={SelectedOption === "ADR" ? true : false}
//                                 onClick={() => {
//                                     setSelectedOption("ADR");
//                                 }}
//                             />
//                             <Form.Check.Label
//                                 htmlFor="ADR"
//                                 className="label-radio"
//                             >
//                                 ADR
//                             </Form.Check.Label>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {chartData && (
//                 <>
//                     <div className="ForecastHorizontalChartInner">
//                         <Line data={chartDetail} options={chartOptions} />
//                     </div>
//                     {api !== 0 && (
//                         <Comments widgetDetails={para} editorId={"BookingPaceChart"} />
//                     )}
//                 </>
//             )}
//             {showNoteSidebar && (
//                 <AddWidgetModal
//                     showModal={showNoteSidebar}
//                     closeModal={closeNoteSideBar}
//                     widgetId={para?.widgetId}
//                     propertyId={propertyDetailFromRTK?.propertyid}
//                     rowTitle={para?.rowTitle}
//                 />
//             )}
//             {widgetModal && (
//                 <WidgetDetailModal
//                     showModal={widgetModal}
//                     closeModal={closeWidgetModal}
//                     data={widgetDetailRef.current}
//                 />
//             )}
//         </div>
//     );
// };

// export default BookinPaceChart;



import React, { useCallback, useEffect, useRef, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { commonService } from "../../../../utils/commonService";
import { setBookingPaceMonth } from "../../../../utils/slices/headerPropertySlice";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import Comments from "../Comments/Comment";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { compName } from "../../../../utils/constant";
import Loader from "../../../Loader/Loader";

/* 🔹 Register chart.js ONCE */
Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
);

const BookinPaceChart = ({ api, para }) => {
  const dispatch = useDispatch();
  const widgetDetailRef = useRef();

  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail,
  );
  const bookingPaceMonth = useSelector(
    (store) => store.headerProperty.bookingPaceMonth,
  );
  const defaultAsOfDateRtk = useSelector(
    (store) => store.headerProperty.defaultAsOfDate,
  );

  const [SelectedOption, setSelectedOption] = useState("Revenue");
  const [chartData, setChartData] = useState(null);
  const [monthList, setMonthList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [widgetModal, setWidgetModal] = useState(false);
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [loading, setLoading] = useState(false);

  const defAsOfDate = moment(para?.asOfDate);
  const [datesArray, setDatesArray] = useState(
    commonService.getAllDatesInMonth(defAsOfDate.year(), defAsOfDate.month()),
  );

  /* 🔹 API CALL */
  const getBookingPaceDetail = useCallback(async () => {
    const asOfDateStr = bookingPaceMonth || para?.asOfDate;
    if (!asOfDateStr) return;

    setLoading(true);

    const m = moment(asOfDateStr);
    const startDate = m.startOf("month").format("YYYY-MM-DD");
    const endDate = m.endOf("month").format("YYYY-MM-DD");

    const payload = {
      AsOfDate: para?.asOfDate,
      startDate: startDate,
      endDate: endDate,
      propertyCode: para?.propertyCode || propertyDetailFromRTK?.propertycode,
    };

    const originalPayload = {
      AsOfDate: bookingPaceMonth || para?.asOfDate,
      propertyCode: para?.propertyCode,
    };

    const [paceResRaw, occResRaw, otbResRaw, ratesResRaw] = await Promise.all([
      apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot + API_URL.BOOKING_PACE.CHART,
          body: originalPayload,
        },
        false
      ),
      apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.RATEIQ_YIELD.GET_OCCUPANCY_BY_DATES,
          body: payload,
        },
        false
      ),
      apiCall(
        {
          method: "POST",
          url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
          body: payload,
        },
        false
      ),
      apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
          body: payload,
        },
        false
      ),
    ]);

    const paceRes = apiResponse(false, paceResRaw);
    const occRes = apiResponse(false, occResRaw);
    const otbRes = apiResponse(false, otbResRaw);
    const ratesRes = apiResponse(false, ratesResRaw);

    const paceDataApi = paceRes?.isValidate ? paceRes?.data?.data || [] : [];
    const occDataApi = occRes?.isValidate ? occRes?.data?.data || [] : [];
    const otbDataApi = otbRes?.isValidate ? otbRes?.data?.data || [] : [];
    const ratesDataApi = ratesRes?.isValidate ? ratesRes?.data?.data || [] : [];

    const prevArea = [];
    const currArea = [];
    const prevBar = [];
    const currBar = [];

    datesArray.forEach((day) => {
      const getMatch = (apiData) =>
        apiData.find((x) => {
          const d = x?.Dates || x?.Date || x?.dates || x?.startdate;
          return (
            d && commonService.convertDateInTimezone(d).getDate() === day
          );
        }) || {};

      const paceMatch = getMatch(paceDataApi);
      const occMatch = getMatch(occDataApi);
      const otbMatch = getMatch(otbDataApi);
      const ratesMatch = getMatch(ratesDataApi);

      // Area data from paceMatch
      let pArea = 0;
      let cArea = 0;
      if (SelectedOption === "Revenue") {
        pArea = paceMatch.TotalRevenuePreviousYear || 0;
        cArea = paceMatch.TotalRevenueCurrentYear || 0;
      } else if (SelectedOption === "Room Sold") {
        pArea = paceMatch.TotalRMSPreviousYear || 0;
        cArea = paceMatch.TotalRMSCurrentYear || 0;
      } else if (SelectedOption === "Occupancy") {
        pArea = paceMatch.OccPerPreviousYear || 0;
        cArea = paceMatch.OccPerCurrentYear || 0;
      } else if (SelectedOption === "ADR") {
        pArea = paceMatch.TotalADRPreviousYear || 0;
        cArea = paceMatch.TotalADRCurrentYear || 0;
      }
      prevArea.push(pArea);
      currArea.push(cArea);

      // Bar data from new APIs
      let pBar = 0;
      let cBar = 0;
      if (SelectedOption === "Revenue") {
        pBar = ratesMatch.lyrevenue || ratesMatch.ly_revenue || 0;
        cBar = otbMatch.REV || 0;
      } else if (SelectedOption === "Room Sold") {
        pBar = occMatch.LY_RMS || 0;
        cBar = occMatch.RMS || 0;
      } else if (SelectedOption === "Occupancy") {
        pBar = occMatch.LY_OCC || 0;
        cBar = occMatch.OCC || 0;
      } else if (SelectedOption === "ADR") {
        pBar = ratesMatch.lyadr || ratesMatch.ly_adr || 0;
        cBar = otbMatch.ADR || 0;
      }
      prevBar.push(pBar);
      currBar.push(cBar);
    });

    const currYear = new Date().getFullYear();
    setChartData([
      {
        type: "line",
        label: `${currYear - 1} ${SelectedOption}`,
        data: prevArea,
        backgroundColor: "#97C2E0",
        fill: { target: "origin", above: "rgba(151,194,224,0.4)" },
        yAxisID: "y",
      },
      {
        type: "line",
        label: `${currYear} ${SelectedOption}`,
        data: currArea,
        backgroundColor: "#7ACFA2",
        fill: { target: "origin", above: "rgba(122,207,162,0.4)" },
        yAxisID: "y",
      },
      {
        type: "bar",
        label: `${currYear - 1} Daily ${SelectedOption}`,
        data: prevBar,
        backgroundColor: "#4A90E2", // darker blue for bar
        yAxisID: "y1",
        hidden: true,
      },
      {
        type: "bar",
        label: `${currYear} Daily ${SelectedOption}`,
        data: currBar,
        backgroundColor: "#3EA055", // darker green for bar
        yAxisID: "y1",
        hidden: true,
      },
    ]);

    setLoading(false);
  }, [datesArray, SelectedOption, bookingPaceMonth, para, propertyDetailFromRTK]);

  /* 🔹 MAIN EFFECT */
  useEffect(() => {
    if (!para?.asOfDate) return;

    const months = commonService.getMonthNamesUntil(para.asOfDate);
    // setMonthList(months);
    if (!monthList.length) {
      let monthsData = commonService.getMonthNamesUntil(para?.asOfDate);
      setMonthList(monthsData);
      // if (monthsData) {
      //     // setSelectedMonth(monthsData[monthsData.length - 1]);
      // }
    }
    setSelectedMonth(months[months.length - 1]);

    const m = moment(para.asOfDate);
    setDatesArray(commonService.getAllDatesInMonth(m.year(), m.month()));
  }, [para?.asOfDate]);

  useEffect(() => {
    if (api !== 0) {
      getBookingPaceDetail();
    }
  }, [getBookingPaceDetail, api]);

  /* 🔹 CHART CONFIG */
  const chartDetail = chartData && {
    labels: datesArray,
    datasets: chartData,
  };

  const chartOptions = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
      axis: "x",
    },
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          title: (context) => context[0].label,
          label: (context) => {
            const label = context.dataset.label;
            const value = context.formattedValue;
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: true,
        position: "top",
      },
    },
    scales: {
      x: {
        title: { display: true, text: "Date" },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        beginAtZero: true,
        title: { display: true, text: SelectedOption },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        beginAtZero: true,
        title: {
          display: true,
          text: `Daily ${SelectedOption === "Room Sold" ? "Rooms" : SelectedOption}`,
        },
        grid: { drawOnChartArea: false },
      },
    },
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BookinPaceChart", "info", "")}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.bookingPaceChart,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
        </div>
      )}
      <div class="d-flex gap-2 align-items-center">
        <Form.Select id={commonService.generateGlobalClickTrackerID("BookinPaceChart", "form-select-onchange", "")}
          className="width150 mb-2"
          value={selectedMonth}
          //   onChange={(e) => {
          //     const monthName = e.target.value;
          //     const m = moment(
          //       `${monthName} ${moment(defaultAsOfDateRtk).year()}`,
          //       "MMMM YYYY",
          //     );

          //     setDatesArray(
          //       commonService.getAllDatesInMonth(m.year(), m.month()),
          //     );
          //     dispatch(
          //       setBookingPaceMonth(m.endOf("month").format("YYYY-MM-DD")),
          //     );
          //     setSelectedMonth(monthName);
          //   }}
        onChange={(e) => {
            const monthName = e.target.value;

            // Reset case
            if (!monthName) {
                dispatch(setBookingPaceMonth(""));
                setSelectedMonth("");
                return;
            }

            const year = moment(defaultAsOfDateRtk).year();

            const selectedMonthMoment = moment(
                `${monthName} ${year}`,
                "MMMM YYYY",
                true
            );

            if (!selectedMonthMoment.isValid()) return;

            // 🔹 Update X-axis days
            setDatesArray(
                commonService.getAllDatesInMonth(
                selectedMonthMoment.year(),
                selectedMonthMoment.month()
                )
            );

            const defaultMoment = moment(defaultAsOfDateRtk);

            let finalAsOfDate;

            // 🔥 MAIN CONDITION
            if (selectedMonthMoment.isSame(defaultMoment, "month")) {
              // Same month → use defaultAsOfDateRtk
              finalAsOfDate = defaultMoment;
            } else {
              // Different month → use end of selected month
              finalAsOfDate = selectedMonthMoment.endOf("month");

              // Safety check (should never exceed defaultAsOfDateRtk)
              if (finalAsOfDate.isAfter(defaultMoment)) {
                finalAsOfDate = defaultMoment;
              }
            }

            dispatch(setBookingPaceMonth(finalAsOfDate.format("YYYY-MM-DD")));
            setSelectedMonth(monthName);
          }}
        >
          {monthList.map((m) => (
            <option key={m}>{m}</option>
          ))}
        </Form.Select>

        <div className="form-groups form-groups-radio-btn mb-2">
          <div className="form-groups-radio">
            <div className="form-radio">
              <input
                type="radio"
                className="form-check-input"
                name="bookingPaceType"
                id="Revenue"
                value="Revenue"
                checked={SelectedOption === "Revenue"}
                onChange={() => setSelectedOption("Revenue")}
              />
              <Form.Check.Label htmlFor="Revenue" className="label-radio">
                Revenue
              </Form.Check.Label>
            </div>

            <div className="form-radio">
              <input
                type="radio"
                className="form-check-input"
                name="bookingPaceType"
                id="RoomSold"
                value="Room Sold"
                checked={SelectedOption === "Room Sold"}
                onChange={() => setSelectedOption("Room Sold")}
              />
              <Form.Check.Label htmlFor="RoomSold" className="label-radio">
                Room Sold
              </Form.Check.Label>
            </div>

            <div className="form-radio">
              <input
                type="radio"
                className="form-check-input"
                name="bookingPaceType"
                id="ADR"
                value="ADR"
                checked={SelectedOption === "ADR"}
                onChange={() => setSelectedOption("ADR")}
              />
              <Form.Check.Label htmlFor="ADR" className="label-radio">
                ADR
              </Form.Check.Label>
            </div>
            <div className="form-radio">
              <input
                type="radio"
                className="form-check-input"
                name="bookingPaceType"
                id="Occupancy"
                value="Occupancy"
                checked={SelectedOption === "Occupancy"}
                onChange={() => setSelectedOption("Occupancy")}
              />
              <Form.Check.Label htmlFor="Occupancy" className="label-radio">
                Occupancy
              </Form.Check.Label>
            </div>
          </div>
        </div>
      </div>

      {chartData ? (
        <div style={{ position: "relative" }}>
          {loading && (
            <div className="chart-loader-overlay">
              <Loader />
            </div>
          )}
          <Line data={chartDetail} options={chartOptions} />
        </div>
      ) : loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
          <Loader />
        </div>
      ) : null}

      {api !== 0 && <Comments widgetDetails={para} />}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={() => setWidgetModal(false)}
          data={widgetDetailRef.current}
        />
      )}
      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={() => setShowNoteSidebar(false)}
        />
      )}
    </div>
  );
};

export default BookinPaceChart;
